<template>
  <div class="photo-accueil">
    <img
      :src="image"
      alt="Erminio"
    />
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
export default {
  name: 'HomeView',
  data() {
    return {
      image: require('@/assets/Photos-accueil/Erminio.jpg'),
    };
  },
  setup() {
    useHead({
      title: 'Home Page',
      meta: [
        { name: 'description', content: 'Pablo Cirès - Bienvenue sur mon site.' },
        { name: 'keywords', content: 'home, réalisateur, documentaires, films' },
        { property: 'og:title', content: 'Home Page - Pablo Cirès' },
        { property: 'og:description', content: 'Bienvenue sur mon site.' },
        { property: 'og:url', content: 'https://www.pablocires.me/home' },
        { property: 'og:type', content: 'website' },
      ],
    });
  },
}
</script>

<style scoped>
.photo-accueil {
  width: 100%;
  height: 93.7vh;
}

.photo-accueil img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
}

</style>